// extracted by mini-css-extract-plugin
export default {"mappingProfilesFormContent":"mappingProfilesFormContent---dI7rf"};